import type { SVGProps } from 'react';

export const Rating = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path
        d="M3.19971 7.92773C3.94516 7.92773 4.55008 8.53194 4.55029 9.27734V14.5781C4.55008 15.3235 3.94516 15.9277 3.19971 15.9277C2.45443 15.9275 1.85031 15.3234 1.8501 14.5781V9.27734C1.85031 8.53207 2.45443 7.92795 3.19971 7.92773ZM8.6001 1.92773C9.34555 1.92773 9.9495 2.53194 9.94971 3.27734V14.5781C9.9495 15.3235 9.34555 15.9277 8.6001 15.9277C7.85465 15.9277 7.2507 15.3235 7.25049 14.5781V3.27734C7.2507 2.53195 7.85465 1.92775 8.6001 1.92773ZM14.0005 4.92773C14.7458 4.92792 15.3499 5.53205 15.3501 6.27734V14.5781C15.3499 15.3234 14.7458 15.9275 14.0005 15.9277C13.255 15.9277 12.6501 15.3235 12.6499 14.5781V6.27734C12.6501 5.53194 13.255 4.92773 14.0005 4.92773Z"
        fill="currentcolor"
      />
    </svg>
  );
};
